/*
 *###############################################################################
 *Module Name                   : PromotionMaster.js                            #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Dinisuru Balasuriya                           #
 *Date                          : Monday , March 7th 2022, 10:10:07 am          #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                           #
 *###############################################################################
 */


import React, { useState } from "react"
import {
    Col,
    Row,
    Button,
    Label
} from "reactstrap"

//**Importing required componant files   */
import DPSwitch from "framework/components/DPSwitch"
import DPDropDown from "framework/components/DPDropDown"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
//**End Importing required componant files */


const PromotionMasterGenContent = ({
    autoCode,
    anniversary,
    setAnniversary,
    birthdayBased,
    setBirthdayBased,
    billValTo,
    setBillValTo,
    billValFrom,
    setBillValFrom,
    promoGroup,
    setPromoGroup,
    timeto,
    setTimeto,
    timefrom,
    setTimefrom,
    dateto,
    setDateto,
    datefrom,
    setDatefrom,
    description,
    setDescription,
    name,
    setName,
    code,
    setCode,
    status,
    setStatus,

    codeButton,
    tog_xlarge,
    modal_xlarge,
    menuName,
    tog_xlarge2,
    modal_xlarge2,
    setBillValFromOnblur,
    setBillValToOnblur,
    codeOnblur,
    disabled,
    disabledCode,
    setDatefromOnblur,
    setDatetoOnblur,
    setTimefromOnblur,
    setTimetoOnblur,
    GetSelectRow,
    GetSelectRow2,
    setPromoGroupOnBlur,
    onButtonClick,
    setDatePertiodTo,
    setDatePertiodFrom,
    datePertiodTo,
    datePertiodFrom,
    menuCode,
    allCompany,
    company,
    setCompany,
    print,
    setPrint,
    showAllFields,
    disableGroupCode,
    setExclusiveItems,
    exclusingItems,
    setLoyaltyCustomers,
    loyaltyCustomers,
    setPromoPriority,
    promoPriority,
    setPromoPriorityOnBlur,
    shwoloyaltyCustomers,
    promoGroupDesc,

    PRO_CUSLIMIT,
    setPRO_CUSLIMIT,
    setPRO_CUSLIMITOnBlur,
    couponRedemption,
    selectCoupon,
    setSelectCoupon,
    inclAct,
    checkComIncItemBun,
    sysGenCouponOnchange,
    sysGenCoupon,
    HandleDaysOfWeek,
    daysOfWeek,
    pricemodeList,
    selectedPricemode,
    setSelectedPricemode,
    isPricemodeEnable,
    companyContribution,
    companyContributionOnchange,
    companyContributionOnblur,
    supplierContribution,
    supplierContributionOnchange,
    supplierContributionOnblur
}) => {


    const [Datatablesub, SetDatatablesub] = useState([])
    const [groupFilter, SetGroupFilter] = useState('a')
    const ApiURL = window.Links.ApiURL

    async function tog_backdrop() {
        tog_xlarge();
    }

    async function tog_backdrop2() {
        tog_xlarge2();
    }

    //default sorted method
    const defaultSorted = [
        {
            dataField: "id",
            order: "asc",
        },
    ]


    const couponSelection = [
        {
            label: "Unique",
            value: 1
        },
        {
            label: "Common",
            value: 2
        }
    ]


    return (
        <React.Fragment>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">

                    <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}
                            >
                                Promotion
                            </Label>
                        </Col>
                        <Col sm={12} md={7} className="mb-4-sm" style={{ paddingRight: 0 }}>

                            <DPTextBoxforgrid
                                value={code}
                                onChange={setCode}
                                placeholder={autoCode}
                                onBlur={codeOnblur}
                                disabled={disabledCode}
                            />


                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm" style={{ paddingLeft: 0 }} >
                            <Button
                                color="primary"
                                className="btn-sm"
                                onClick={onButtonClick}
                                disabled={codeButton}
                                style={{ height: '30px' }}
                            >
                                <i
                                    className="mdi mdi-new-box"
                                    style={{ fontSize: "12px" }}
                                ></i>
                            </Button>
                        </Col>

                        <Col sm={12} md={1} className="mb-4-sm" style={{ paddingLeft: 0 }}>
                            <Button
                                onClick={() => {
                                    tog_backdrop()
                                }}
                                color="success"
                                className="btn-sm"
                                disabled={disabledCode}
                            >
                                <i
                                    className="mdi mdi-search-web"
                                    style={{ fontSize: "12px" }}
                                ></i>
                            </Button>
                        </Col>
                    </Row>

                    <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}
                            >
                                Promotion Group
                            </Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={promoGroup}
                                onChange={setPromoGroup}
                                disabled={disableGroupCode}
                                onBlur={setPromoGroupOnBlur}
                            />
                        </Col>
                        <Col sm={12} md={6} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={promoGroupDesc}
                                disabled={true}
                                titleEnable={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm" style={{ padding: 0 }}>
                            <Button
                                onClick={() => {
                                    tog_backdrop2()
                                }}
                                color="success"
                                className="btn-sm"
                                disabled={disableGroupCode}
                            >
                                <i
                                    className="mdi mdi-search-web"
                                    style={{ fontSize: "12px" }}
                                ></i>
                            </Button>
                        </Col>
                    </Row>

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Description *</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={name}
                                onChange={setName}
                                disabled={disabled}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-2">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Narration</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                textType={'textarea'}
                                value={description}
                                onChange={setDescription}
                                disabled={disabled}
                            />
                        </Col>
                    </Row> : null}


                    {showAllFields ?

                        <Row className="mb-0">
                            <Col sm={12} md={3} className="mb-4-sm">
                                <Label htmlFor="example-text-input"
                                    className={`col-md-12 col-form-label-sm`}>
                                    Company *</Label>
                            </Col>
                            <Col sm={12} md={9} className="mb-4-sm">
                                <DPDropDown
                                    selectedGroup={company}
                                    onChange={setCompany}
                                    optionGroup={allCompany}
                                    labelHide={true}
                                    disabled={disabled}
                                />
                            </Col>
                        </Row>



                        : null}

                    {couponRedemption ?
                        <Row className="mb-0">
                            <Col sm={12} md={3} className="mb-4-sm">
                                <Label htmlFor="example-text-input"
                                    className={`col-md-12 col-form-label-sm`}>
                                    Coupon</Label>
                            </Col>
                            <Col sm={12} md={9} className="mb-4-sm">
                                <DPDropDown
                                    selectedGroup={selectCoupon}
                                    onChange={setSelectCoupon}
                                    optionGroup={couponSelection}
                                    labelHide={true}
                                    disabled={disabled}
                                />
                            </Col>
                        </Row>
                        : null}


                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Bill Value Range</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={billValFrom}
                                onChange={setBillValFrom}
                                textAlign="right"
                                onBlur={setBillValFromOnblur}
                                disabled={disabled}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                To</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={billValTo}
                                onChange={setBillValTo}
                                textAlign="right"
                                onBlur={setBillValToOnblur}
                                disabled={disabled}
                            />
                        </Col>
                    </Row> : null}


                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Status</Label>

                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPSwitch

                                checked={status}
                                onChange={setStatus}
                                disabled={disabled}
                            />
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Print</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPSwitch
                                checked={print}
                                onChange={setPrint}
                                disabled={disabled}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">

                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Anniversary</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPSwitch
                                checked={anniversary}
                                onChange={setAnniversary}
                                disabled={disabled ? true : birthdayBased}
                            />
                        </Col>
                        {shwoloyaltyCustomers ? <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                loyalty Customers</Label>
                        </Col> : null}
                        {shwoloyaltyCustomers ? <Col sm={12} md={3} className="mb-4-sm">
                            <DPSwitch
                                checked={loyaltyCustomers}
                                onChange={setLoyaltyCustomers}
                                disabled={disabled}
                            />
                        </Col> : null}
                    </Row> : null}
                    {showAllFields ? <Row className="mb-0">

                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Check Validity Per Item</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPSwitch
                                checked={exclusingItems}
                                onChange={setExclusiveItems}
                                disabled={disabled}
                            />
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Promo Priority</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={promoPriority}
                                onChange={setPromoPriority}
                                textAlign="right"
                                onBlur={setPromoPriorityOnBlur}
                                disabled={disabled}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Birthday</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPSwitch
                                checked={birthdayBased}
                                onChange={setBirthdayBased}
                                disabled={disabled ? true : anniversary }

                            />
                        </Col>

                        {shwoloyaltyCustomers ? <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Promotion Count</Label>
                        </Col> : null}
                        {shwoloyaltyCustomers ? <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={PRO_CUSLIMIT}
                                onChange={setPRO_CUSLIMIT}
                                onBlur={setPRO_CUSLIMITOnBlur}
                                textAlign="right"
                                disabled={disabled}
                            />
                        </Col> : null}

                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Start Date</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={datePertiodFrom}
                                onChange={setDatePertiodFrom}
                                textAlign="right"
                                disabled={disabled ? true : (birthdayBased || anniversary) ? false : true}
                            />
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                End Date</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={datePertiodTo}
                                onChange={setDatePertiodTo}
                                textAlign="right"
                                disabled={disabled ? true : (birthdayBased || anniversary) ? false : true}
                            />
                        </Col>
                    </Row> : null}



                </Col>
                <Col sm={12} md={6} className="mb-4-sm">

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Date Period *</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                textType={'date'}
                                value={datefrom}
                                onChange={setDatefrom}
                                disabled={disabled}
                                onBlur={setDatefromOnblur}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                To</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                textType={'date'}
                                value={dateto}
                                onChange={setDateto}
                                disabled={disabled}
                                onBlur={setDatetoOnblur}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Time Period *</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                textType={'time'}
                                value={timefrom}
                                onChange={setTimefrom}
                                disabled={disabled}
                                onBlur={setTimefromOnblur}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                To</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                textType={'time'}
                                value={timeto}
                                onChange={setTimeto}
                                disabled={disabled}
                                onBlur={setTimetoOnblur}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-2">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Days *</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm" style={{ display: 'grid', gridTemplateColumns: 'auto auto auto auto auto' }}>
                            {daysOfWeek.map((item, index) => (
                                <div style={{ justifyContent: 'center' }}>
                                    <Row style={{ justifyContent: 'center' }}>
                                        <Label htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}>
                                            {item.name}
                                        </Label>
                                    </Row>
                                    <Row>
                                        <DPSwitch
                                            checked={item.state}
                                            onChange={(e) => HandleDaysOfWeek(index, e)}
                                            disabled={disabled}
                                        />
                                    </Row>
                                </div>
                            ))}
                        </Col>
                    </Row> : null}
                    {showAllFields && inclAct ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Item Bundle Combination Check</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPSwitch
                                checked={checkComIncItemBun}
                                disabled={true}
                            />
                        </Col>
                    </Row> : null}
                    {showAllFields && couponRedemption ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                System Generated Coupon</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPSwitch
                                checked={sysGenCoupon}
                                onChange={sysGenCouponOnchange}
                                disabled={disabled}
                            />
                        </Col>
                    </Row> : null}
                    {showAllFields && isPricemodeEnable ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Price Mode
                            </Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPDropDown
                                rowClass="mb-4-sm"
                                labelText=""
                                labelHide={true}
                                optionGroup={pricemodeList}
                                selectedGroup={selectedPricemode}
                                onChange={setSelectedPricemode}
                                disabled={disabled}
                                id={"txtPriceMode"}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Company Contribution
                            </Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                textType={'text'}
                                value={companyContribution}
                                onChange={companyContributionOnchange}
                                disabled={disabled}
                                onBlur={companyContributionOnblur}
                                textAlign={'right'}
                            />
                        </Col>
                    </Row> : null}


                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>
                                Supplier Contribution
                            </Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                textType={'text'}
                                value={supplierContribution}
                                onChange={supplierContributionOnchange}
                                disabled={disabled}
                                onBlur={supplierContributionOnblur}
                                textAlign={'right'}
                            />
                        </Col>
                    </Row> : null}

                </Col>

                <DPSearchBoxDynamic
                    searchData={Datatablesub}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Promotion Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlarge}
                    toggle={tog_xlarge}
                    getSelect={GetSelectRow}
                    APIURL={ApiURL}
                    URLPath={"PROMO"}
                    MenuCode={menuCode}
                    KeyVal={'PROMO'}
                    searchBy={'PRO_CODE'}
                    FilterStr={groupFilter}
                />

                <DPSearchBoxDynamic
                    searchData={Datatablesub}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={menuName + " Group Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlarge2}
                    toggle={tog_xlarge2}
                    getSelect={GetSelectRow2}
                    APIURL={ApiURL}
                    URLPath={"PROMOGRP"}
                    MenuCode={menuCode}
                    KeyVal={'PROMO'}
                    searchBy={'PG_CODE'}
                    FilterStr={groupFilter}
                />


            </Row>
        </React.Fragment>
    )
}
export default PromotionMasterGenContent
